const Health = () => {
  return (
    <>
      <p>healthy</p>
    </>
  )
}

export default Health